import { marketPeriodHelper } from "app/helpers/marketPeriodHelper";
import { MarketsHelper } from "app/helpers/marketsHelper";
import { EventStatus } from "app/utils/const";
import isEmpty from "lodash/isEmpty";
import type { Element } from "React";
import { Component } from "react";
import { injectIntl, intlShape } from "react-intl";
import { $Values } from "utility-types";
import type {
  EventMarketPeriodType,
  EventType,
} from "../../../../../../../../types/eventType";
import Collapsible from "../../../../../../../Collapsible/Collapsible";
import MarketRunnerDetails from "../components/MarketRunnerDetails/MarketRunnerDetails";
import MarketSubHeadings from "../components/MarketSubHeadings/MarketSubHeadings";
import ExchangeMarketTypeHeader from "./components/ExchangeMarketTypeHeader";
import MarketTypeHeader from "./components/MarketTypeHeader ";
import "./MarketPeriodsMarketTypes.scss";
type Props = {
  event: EventType;
  marketPeriod: EventMarketPeriodType;
  marketType: Record<string, any>;
  intl: $Values<typeof intlShape>;
};
type State = {
  isActive: boolean;
}; //

class MarketPeriodsSummaryMarketTypes extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isActive: true,
    };
  }

  toggle: () => void = () => {
    this.setState({
      isActive: !this.state.isActive,
    });
  };
  //
  addMarketDetails: (markets: any, marketType: any) => any = (
    markets: Record<string, any>,
    marketType: Record<string, any>
  ) => {
    return markets.map(market => {
      return (
        <div
          className={`add-market-details ${market.id} ${
            market.status === EventStatus.SUSPENDED
              ? "add-market-details--suspended"
              : ""
          }`}
          key={"add-market-details" + market.id}
        >
          <MarketRunnerDetails
            event={this.props.event}
            market={market}
            marketType={marketType}
          />
        </div>
      );
    });
  };

  showMarketPeriod(marketType: any): boolean {
    // Check that there is at least one market OPEN
    let showMarketPeriod = false;

    if (
      marketType.markets &&
      marketType.markets.length === 1 &&
      !marketType.markets[0].runners
    ) {
      showMarketPeriod = false;
    } else if (marketType.markets) {
      marketType.markets.forEach(market => {
        if (
          market.status === EventStatus.OPEN ||
          market.status === EventStatus.SUSPENDED
        ) {
          showMarketPeriod = true;
        }
      });
    }

    return showMarketPeriod;
  }

  render(): null | Element<"div"> {
    const { event, marketType, marketPeriod, intl } = this.props;

    if (!this.showMarketPeriod(marketType)) {
      return null;
    }

    const homeTeam = event.showHomePlayerAsFirst
      ? event.participant1
      : event.participant2;
    const awayTeam = event.showHomePlayerAsFirst
      ? event.participant2
      : event.participant1;
    const showMarketPeriodName = marketPeriodHelper.showMarketPeriodName(
      marketPeriod.marketPeriod
    );
    const showMarketQuarterName = marketPeriodHelper.showMarketQuarterName(
      marketPeriod.marketPeriod
    );

    return (
      <div
        className={`unsummarized-markets-modal__market-types ${marketType.marketType.toLowerCase()}`}
      >
        <Collapsible
          status={event.status.toLowerCase()}
          onToggle={() => this.toggle()}
          header={
            <div
              className={`collapsible-header ${
                marketType && MarketsHelper.isMatchOdds(marketType.marketType)
                  ? "exchange "
                  : ""
              }`}
            >
              <MarketTypeHeader
                event={event}
                showMarketPeriodName={showMarketPeriodName}
                showMarketQuarterName={showMarketQuarterName} // If applicable
                marketPeriod={marketPeriod}
                marketType={marketType}
                homeTeam={homeTeam}
                awayTeam={awayTeam}
              />

              {marketType &&
                MarketsHelper.isMatchOdds(marketType.marketType) && (
                  <ExchangeMarketTypeHeader />
                )}
            </div>
          }
          content={
            <div
              key={"market-period" + event.id}
              className="collapsible-content"
            >
              {/* add markets sub heading and market details */}
              {!isEmpty(marketType.markets) && (
                <MarketSubHeadings
                  market={marketType.markets[0]}
                  marketType={marketType}
                  event={event}
                />
              )}
              {!isEmpty(marketType.markets) &&
                this.addMarketDetails(marketType.markets, marketType)}
            </div>
          }
          isActive={this.state.isActive}
          withArrows
        />
      </div>
    );
  }
}

export default injectIntl(MarketPeriodsSummaryMarketTypes) as any;
